import React from "react";

import ApplicationProcedureYEI from "./ApplicationProcedureYEI";
import CareerOptionsYEI from "./CareerOptionsYEI";
import EligibilityYEI from "./EligibilityYEI";
import ObjectivesYEI from "./ObjectivesYEI";
import OutcomesYEI from "./OutcomesYEI";
import OverviewYEI from "./OverviewYEI";
import ProgramModulesYEI from "./ProgramModulesYEI";

const YEI = () => {
  return (
    <div>
      <section id="overview" className="scroll-mt-40">
        <OverviewYEI />
      </section>
      <section id="objectives" className="scroll-mt-40">
        <ObjectivesYEI />
      </section>
      <section id="eligibility" className="scroll-mt-40">
        <EligibilityYEI />
      </section>
      <section id="application-procedure" className="scroll-mt-40">
        <ApplicationProcedureYEI />
      </section>
      <section id="program-modules" className="scroll-mt-40">
        <ProgramModulesYEI />
      </section>
      <section id="career-options" className="scroll-mt-40">
        <CareerOptionsYEI />
      </section>
      <section id="outcomes" className="scroll-mt-40">
        <OutcomesYEI />
      </section>
    </div>
  );
};

export default YEI;
